// BASE
const WEBPAGE = '/webpage'
const COMMON = '/common'
const BACK_OFFICE = '/back-office'
const HOME = '/'
const ABOUT_US = '/about-us'
const CERTIFICATION = '/certifications'
const CONTACT_US = '/contact-us'
const GALLERY = '/gallery'
const TUK = '/tuk'
const ASSESSOR = '/assessor'
const AUTH = '/auth'
const NEWS = '/news'
const ACCOUNT = '/account'

// BASE AUTH MODULE
export const AUTH_MODULE = AUTH

// BASE ACCOUNT MODULE
export const ACCOUNT_MODULE = ACCOUNT

// BASE WEBPAGE MODULE
export const HOME_MODULE = `${WEBPAGE}/`
export const ABOUT_US_MODULE = `${WEBPAGE}/${ABOUT_US}`
export const CERTIFICATION_MODULE = `${WEBPAGE}/${CERTIFICATION}`
export const ASSESSOR_MODULE = `${WEBPAGE}/${ASSESSOR}`
export const CONTACT_US_MODULE = `${WEBPAGE}/${CONTACT_US}`
export const GALLERY_MODULE = `${WEBPAGE}/${GALLERY}`
export const TUK_MODULE = `${WEBPAGE}/${TUK}`
export const NEWS_MODULE = `${WEBPAGE}/${NEWS}`

// BASE COMMON MODULE
export const COMMON_MODULE = COMMON

// BASE BACK OFFICE MODULE
export const BACK_OFFICE_MODULE = BACK_OFFICE
export const PERSONAL_DATA_MODULE = `${BACK_OFFICE}/personal-data`
export const USER_MODULE = `${BACK_OFFICE}/users`
export const USER_DETAIL_MODULE = `${BACK_OFFICE}/user-detail`
export const CERTIFICATE_SUBMISSION_STATUS_MODULE = `${BACK_OFFICE}/certificate-submission-status`
export const CONTENT_MODULE = `${BACK_OFFICE}/contents`
export const APPROVAL_CERTIFICATION_SCHEMA_MODULE = `${BACK_OFFICE}/approval-certification-schema`
export const SET_SELF_ASSESSMENT_FORM_MODULE = `${BACK_OFFICE}/set-self-assessment-form`
export const QA_MODULE = `${BACK_OFFICE}/qa`
export const USER_ACCESS_MODULE = `${BACK_OFFICE}/user-accesses`
export const MASTER_MODULE = `${BACK_OFFICE}/master`
export const ASSESSMENT_MODULE = `${BACK_OFFICE}/assessments`

// AUTH
export const AUTH_URL = {
  LOGIN: `${AUTH_MODULE}/login`,
  CHANGE_ROLE: `${AUTH_MODULE}/change-role`,
}

// ACCOUNT
export const ACCOUNT_URL = {
  LOGIN_CALLBACK: `${ACCOUNT_MODULE}/login-callback`,
  LOGIN_SILENT_CALLBACK: `${ACCOUNT_MODULE}/login-silent-callback`,
  LOGOUT_CALLBACK: `${ACCOUNT_MODULE}/logout-callback`,
}

// WEBPAGE - HOME
export const HOME_URL = {
  INDEX: HOME,
}

// WEBPAGE - ABOUT US
export const ABOUT_US_URL = {
  INDEX: ABOUT_US,
}

// WEBPAGE - CERTIFICATION
export const CERTIFICATION_URL = {
  INDEX: CERTIFICATION,
  REGISTRATION: `${CERTIFICATION}/registration/`,
  REGISTRATION_SELF_ASSESSMENT: `${CERTIFICATION}/registration/self-assessment/`,
}

// WEBPAGE - ASSESSOR
export const ASSESSOR_URL = {
  INDEX: ASSESSOR,
}

// WEBPAGE - CONTACT US
export const CONTACT_US_URL = {
  INDEX: CONTACT_US,
}

// WEBPAGE - TUK
export const TUK_URL = {
  INDEX: TUK,
}

// WEBPAGE - GALLERY
export const GALLERY_URL = {
  INDEX: GALLERY,
}

// WEBPAGE - GALLERY
export const NEWS_URL = {
  INDEX: NEWS,
}

// BACK OFFICE - PROFILE
export const PERSONAL_DATA_URL = {
  PROFILE: `${PERSONAL_DATA_MODULE}/profile`,
  COMPANY: `${PERSONAL_DATA_MODULE}/company`,
  MY_DOCUMENT: `${PERSONAL_DATA_MODULE}/my-documents`,
  ADDITIONAL_QUESTION: `${PERSONAL_DATA_MODULE}/additional-question`
}

// BACK OFFICE - USER MANAGEMENT
export const USER_URL = {
  WAITING_APPROVAL: `${USER_MODULE}/waiting-approval`,
  APPROVED: `${USER_MODULE}/approved`,
  REJECTED: `${USER_MODULE}/rejected`,
  USER_DETAIL: `${USER_MODULE}`
}

// BACK OFFICE - CERTIFICATE_SUBMISSION_STATUS
export const CERTIFICATE_SUBMISSION_STATUS_URL = {
  INDEX: CERTIFICATE_SUBMISSION_STATUS_MODULE,
}

// BACK OFFICE - CONTENT MANAGEMENT
export const CONTENT_URL = {
  HOMEPAGE: `${CONTENT_MODULE}/homepage`,
  ABOUT_US: `${CONTENT_MODULE}/about-us`,
  CERTIFICATION: `${CONTENT_MODULE}/certifications`,
  ASSESSOR: `${CONTENT_MODULE}/assessors`,
  TUK: `${CONTENT_MODULE}/tuk`,
  GALLERY: `${CONTENT_MODULE}/galleries`,
  CONTACT_US: `${CONTENT_MODULE}/contact-us`,
}

// BACK OFFICE - APPROVAL CERTIFICATION SCHEMA
export const APPROVAL_CERTIFICATION_SCHEMA_URL = {
  INDEX: APPROVAL_CERTIFICATION_SCHEMA_MODULE,
}

// BACK OFFICE - SET SELF ASSESSMENT FORM
export const SET_SELF_ASSESSMENT_FORM_URL = {
  INDEX: SET_SELF_ASSESSMENT_FORM_MODULE,
}

// BACK OFFICE - QA
export const QA_URL = {
  INDEX: QA_MODULE,
}

// BACK OFFICE - USER ACCESS
export const USER_ACCESS_URL = {
  INDEX: USER_ACCESS_MODULE,
}

// BACK OFFICE - MASTER
export const MASTER_URL = {
  COMPANY: `${MASTER_MODULE}/companies`,
  BRANCH: `${MASTER_MODULE}/branches`,
  DIVISION: `${MASTER_MODULE}/divisions`,
  ROLE: `${MASTER_MODULE}/roles`,
  ROLE_ACCESS: `${MASTER_MODULE}/user-accesses`,
  FIELD: `${MASTER_MODULE}/field`,
  CERTIFICATION_SCHEMA: `${MASTER_MODULE}/certification-schemas`,
  CERTIFICATION_SCHEMA_FIELD: `${MASTER_MODULE}/certification-schema-fields`,
  TUK_TYPE: `${MASTER_MODULE}/tuk-types`,
  TUK: `${MASTER_MODULE}/tuk`,
  TUK_MATCH_TYPE: `${MASTER_MODULE}/tuk-match-types`,
  CATEGORY: `${MASTER_MODULE}/categories`,
  PROGRAM_TYPE: `${MASTER_MODULE}/program-types`,
  DOCUMENT_DETAIL: `${MASTER_MODULE}/document-details`,
  DOCUMENT_PROOF: `${MASTER_MODULE}/document-proofs`,
}

// ASSESSMENT
export const ASSESSMENT_URL = {
  INDEX: `${ASSESSMENT_MODULE}`,
}

// COMMON
export const COMMON_URL = {
  UNAUTHORIZED: `${COMMON_MODULE}/unauthorized`,
  VERIFY_USER: `${COMMON_MODULE}/verify-user`,
  NOT_FOUND: `${COMMON_MODULE}/not-found`,
  ALL: '*',
}
